import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { PageHeader } from 'ui/components';

import './PageContainer.scss';

export default class PageContainer extends Component {
	static propTypes = {
		headerText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
		children: PropTypes.object,
	};

	static defaultProps = {
		headerText: '',
		children: [],
	};

	render() {
		const { headerText, children } = this.props;

		return (
			<div className="PageContainer">
				<PageHeader headerText={headerText} />

				{React.Children.toArray(children)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/PageContainer/index.js